import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SkeletonSizeBase } from '../../../common/Models/SkeletonSizesBase';

@Component({
  selector: 'skc-chart-legend',
  templateUrl: './chart-legend.component.html',
  styleUrls: ['./chart-legend.component.less']
})
export class ChartLegendComponent extends SkeletonSizeBase implements OnInit, OnChanges {
  @Input('skc-legend-width') legendWidth;
  @Input('skc-legend-height') legendHeight;
  @Input('skc-total-legends') totalLegends;
  legends;

  constructor() {
    super();
  }

  ngOnInit() {
    this.initProperties();
  }

  private initProperties() {
    if (!this.legendWidth) {
      this.legendWidth = '7em';
    }
    if (!this.legendHeight) {
      this.legendHeight = '5em';
    }
    if (!this.totalLegends) {
      this.totalLegends = 1;
    }
    this.legends = new Array(this.totalLegends).fill({});
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.totalLegends.firstChange) {
      this.legends = new Array(this.totalLegends).fill({});
    }
  }
}
